import React, { Component } from "react";
import { Treebeard } from "react-treebeard";
import { connect } from "react-redux";
import { Card } from "react-bootstrap";

class CategoryTree extends Component {
  constructor(props) {
    super(props);

    this.state = { cursor: null };
  }

  onToggle = (node, toggled) => {
    node.active = true;

    if (node.children) {
      node.toggled = toggled;
    }

    this.setState({ cursor: node });

    this.props.history.push(`/category/${node.id}`);
  };

  render() {
    return (
      <Card>
        <Card.Header className="bg-primary text-white">
          Browse By Category
        </Card.Header>
        <Card.Body>
          <Treebeard
            data={this.props.categoryTree}
            onToggle={this.onToggle}
            style={this.style}
          />
        </Card.Body>
      </Card>
    );
  }

  style = {
    tree: {
      base: {
        listStyle: "none",
        backgroundColor: "transparent",
        margin: 0,
        padding: 0,
        color: "#000",
        fontFamily:
          'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
        fontSize: "14px"
      },
      node: {
        base: {
          position: "relative",
          margin: "5px 0"
        },
        link: {
          cursor: "pointer",
          position: "relative",
          padding: 0,
          display: "block"
        },
        activeLink: {
          background: "transparent"
        },
        toggle: {
          base: {
            position: "relative",
            display: "inline-block",
            verticalAlign: "top",
            marginLeft: "-5px",
            height: "24px",
            width: "24px"
          },
          wrapper: {
            position: "absolute",
            top: "50%",
            left: "50%",
            margin: "-7px 0 0 -7px",
            height: "14px"
          },
          height: 14,
          width: 14,
          arrow: {
            fill: "#000",
            strokeWidth: 0
          }
        },
        header: {
          base: {
            display: "inline-block",
            verticalAlign: "top",
            color: "#000"
          },
          connector: {
            width: "2px",
            height: "12px",
            borderLeft: "solid 2px black",
            borderBottom: "solid 2px black",
            position: "absolute",
            top: "0px",
            left: "-21px"
          },
          title: {
            lineHeight: "24px",
            verticalAlign: "middle"
          }
        },
        subtree: {
          listStyle: "none",
          paddingLeft: "19px"
        },
        loading: {
          color: "#000"
        }
      }
    }
  };
}

export default connect(({ categoryTree }) => ({ categoryTree }))(CategoryTree);
